module.exports = __webpack_public_path__ + "img/user23.a2c6f8ec.jpg";